import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { navLinks } from '@/mocks/home';

const LOGO_URL = 'https://static.readdy.ai/image/1e2bcd3c0f3a6486828146077360f404/6779162182ed6d3a577de7e05a94991c.png';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location.pathname]);

  const isHome = location.pathname === '/';
  const transparent = isHome && !scrolled;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        transparent
          ? 'bg-transparent'
          : 'bg-background-50/90 backdrop-blur-xl border-b border-background-200/50'
      }`}
    >
      <div className="w-full px-4 md:px-8 lg:px-12">
        <nav className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-2.5 shrink-0">
            <img
              src={LOGO_URL}
              alt="析莜科技"
              className="h-7 md:h-9 w-auto"
            />
            {/* Logo text lockup - both ends aligned */}
            <div className="flex flex-col leading-none w-16 md:w-[72px]">
              <span
                className={`text-base md:text-lg font-bold font-heading transition-colors duration-300 ${
                  transparent ? 'text-white' : 'text-foreground-50'
                }`}
              >
                析莜科技
              </span>
              {/* Letter-by-letter justified layout to match Chinese width */}
              <div className={`flex justify-between text-[8px] md:text-[9px] font-label uppercase transition-colors duration-300 mt-0.5 ${
                transparent ? 'text-white/50' : 'text-foreground-300'
              }`}>
                {'XIYOOTECHNOLOGY'.split('').map((char, i) => (
                  <span key={i}>{char}</span>
                ))}
              </div>
            </div>
          </Link>

          {/* Desktop Nav */}
          <ul className="hidden md:flex items-center gap-8 lg:gap-10">
            {navLinks.map((link) => (
              <li key={link.href}>
                <Link
                  to={link.href}
                  className={`text-sm font-medium whitespace-nowrap transition-colors duration-300 hover:text-primary-400 ${
                    transparent
                      ? 'text-white/80'
                      : location.pathname === link.href
                        ? 'text-primary-400'
                        : 'text-foreground-200'
                  }`}
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>

          {/* Mobile Hamburger */}
          <button
            type="button"
            className={`md:hidden w-10 h-10 flex items-center justify-center transition-colors ${
              transparent ? 'text-white' : 'text-foreground-100'
            }`}
            onClick={() => setMobileOpen(!mobileOpen)}
            aria-label="切换导航菜单"
          >
            <i className={`ri-${mobileOpen ? 'close' : 'menu'}-line text-2xl`} />
          </button>
        </nav>
      </div>

      {/* Mobile Menu */}
      <div
        className={`md:hidden absolute top-full left-0 right-0 bg-background-50/98 backdrop-blur-xl border-b border-background-200/50 transition-all duration-300 overflow-hidden ${
          mobileOpen ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <ul className="px-4 py-4 space-y-1">
          {navLinks.map((link) => (
            <li key={link.href}>
              <Link
                to={link.href}
                className={`block py-3 px-4 text-sm font-medium rounded-lg transition-colors ${
                  location.pathname === link.href
                    ? 'text-primary-400 bg-primary-950/30'
                    : 'text-foreground-200 hover:bg-background-100'
                }`}
              >
                {link.label}
              </Link>
            </li>
          ))}
        </ul>
      </div>
    </header>
  );
}